async function tryCatch(promise) {
  try {
    const data = await promise;
    return { data, error: void 0, success: true };
  } catch (error) {
    return { data: void 0, error, success: false };
  }
}
export {
  tryCatch
};
//# sourceMappingURL=try-catch.mjs.map